import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Resolve, RouterStateSnapshot} from '@angular/router';
import {TenantSelectorService} from "../../services/tenant-selector.service";
import {ThemingService} from "../../theming.service";

@Injectable({
  providedIn: 'root',
})
export class NoTenantGuard implements CanActivate {
  constructor(
    private tenantSelector: TenantSelectorService,
    private themingService: ThemingService,
  ) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    this.tenantSelector.selectTenant(null);
    return this.themingService.loadApplicationTheme().then(() => true);
  }
}
